import React, { useEffect, useState } from 'react'
import Topbar from "../components/Layout/Topbar"
import { Sidebar } from '../components/Layout/Sidebar'
import DeliveryListing from '../components/CreateDeliveryOrder.js/DeliveryListing'
import { useSelector } from 'react-redux'
import UpdateDeliveryModal from '../components/CreateDeliveryOrder.js/UpdateDeliveryModal'
import { supabase, uploadFile, getFileUrl } from '../supabase.config'
import imageCompression from "browser-image-compression";
import { emitOrderNotification } from '../utils/notificationService';
import { syncDeliveryAssignmentStatusForOrder } from '../utils/deliveryAssignmentService';
const DeliveryBoyList = () => {
  const [pickupList, setPickupList] = useState([])
  const { error, loading, isAuthenticated, users, userProfile } = useSelector(
    (state) => state.user
  );
  const [updateModal, setUpdateModal] = useState(false)
  const [deliveryId, setDeliveryId] = useState("")
  const [lrNumberdata, setLrNumberdata] = useState([])
  const [lrNumberdil, setLrNumberdil] = useState("")
  const [lrNumber, setLrNumber] = useState("")
  const [orderDetail, setOrderDetail] = useState({})
  const [dilveryBoyStatusDetails, setdilveryBoyStatusDetails] = useState({})
  const [deliveryBoyList, setDeliveryBoyList] = useState([])
  const [orderList, setOrderList] = useState([])
  const [orderActivity, setOrderActivity] = useState([])
  const [status, setStatus] = useState("")
  const [pod, setPod] = useState("")
  const [reason, setReason] = useState("")
  const [loadingPod, setloadingPod] = useState(false)
  const [progress, setProgress] = useState(0);
  const [deliveryBoyStatus, setDeliveryBoyStatus] = useState("")
  const actorUserId = userProfile?.id || userProfile?.uid || users || null
  console.log(lrNumberdata)
  console.log(orderList)
  const handleUpdateStatus = async () => {
    if (!deliveryId) return false
    const date = new Date()
    const { data: current, error } = await supabase.from('orders').select('*').eq('id', deliveryId).single()
    if (error || !current) {
      console.error('Failed to load order for update', error)
      return false
    }
    const pkg = (typeof current.package_details === 'object') ? current.package_details : (()=>{ try{return JSON.parse(current.package_details||'{}')}catch{return {}}})()
    const updatedPkg = {
      ...pkg,
      orderActivity: [...(pkg.orderActivity || []), {
        status,
        remark: (status === 'Undelivered') ? reason : 'Order Has been Delivered',
        location: (status === 'Undelivered') ? 'Check Remark' : 'Delivery Location',
        time: date
      }],
      pod: status === 'delivered' ? (pod || pkg.pod) : (pkg.pod || ''),
      undelivered_reason: status === 'Undelivered' ? (reason || pkg.undelivered_reason) : (pkg.undelivered_reason || ''),
      undelivered_pod: status === 'Undelivered' ? (pod || pkg.undelivered_pod) : (pkg.undelivered_pod || '')
    }
    const { error: updErr } = await supabase
      .from('orders')
      .update({ status, package_details: updatedPkg })
      .eq('id', deliveryId)
    if (updErr) {
      console.error('Failed to update order status', updErr)
      return false
    }
    await emitOrderNotification({
      actorUserId,
      order: { ...current, status, package_details: updatedPkg },
      eventType: status === 'delivered' ? 'order_delivered' : 'order_delivery_exception',
      title: status === 'delivered' ? 'Order delivered' : 'Delivery update recorded',
      message: status === 'delivered'
        ? `Order ${current?.tracking_number || current?.order_number || current?.order_id || ''} was marked delivered.`
        : `Order ${current?.tracking_number || current?.order_number || current?.order_id || ''} was updated to ${status}.`,
      metadata: {
        reason: reason || '',
      },
    })
    if (String(status).toLowerCase() === 'delivered') {
      await syncDeliveryAssignmentStatusForOrder({ ...current, status, package_details: updatedPkg })
    }
    // Optimistically update local list
    setOrderList((prev) => prev.map(o => o.id === deliveryId ? { ...o, status } : o))
    return true
  }
  /** ✅ Update delivery boy status */
  const handleDeliveryBoyStatus = async () => {
    try {
      const today = new Date(); today.setHours(0,0,0,0)
      const uid = userProfile?.id || userProfile?.uid
      if (!uid) return
      const { data, error } = await supabase
        .from('delivery_boy_data')
        .select('id, created_at, assigned_user')
        .order('created_at', { ascending: false })
      if (error) return
      const mineToday = (data||[]).filter(row => {
        const au = row.assigned_user
        const sameId = au && (au.id === uid || au.uid === uid)
        const d = row.created_at ? new Date(row.created_at) : null
        if (d) d.setHours(0,0,0,0)
        return sameId && d && d.getTime() === today.getTime()
      })
      for (const row of mineToday) {
        await supabase
          .from('delivery_boy_data')
          .update({ delivery_boy_status: status === 'Undelivered' ? `Undelivered (${reason})` : 'Complete' })
          .eq('id', row.id)
      }
    } catch (error) {
      console.error('Error updating delivery boy status:', error)
    }
  };

  const handleUpdateModal = () => {
    setUpdateModal(!updateModal)
  }


  console.log(deliveryId)

  const fetchOrderDetails = async (id) => {
    const { data, error } = await supabase.from('orders').select('*').eq('id', id).single()
    if (error) return
    const pkg = (typeof data.package_details === 'object') ? data.package_details : (()=>{ try{return JSON.parse(data.package_details||'{}')}catch{return {}}})()
    setOrderDetail(data)
    setOrderActivity(pkg.orderActivity || [])
  }

  const addPOD = async (e) => {
    e.preventDefault()
    setloadingPod(true)
    const raw = e.target[0]?.files[0]
    if (!raw) return setloadingPod(false)
    try {
      const options = { maxSizeMB: 1, maxWidthOrHeight: 1280, useWebWorker: true }
      const file = await imageCompression(raw, options)
      const path = `pod/${Date.now()}_${file.name}`
      const { error } = await uploadFile('documents', path, file)
      if (error) throw error
      const url = getFileUrl('documents', path)
      setPod(url)
    } catch (err) {
      alert(err.message || 'Failed to upload')
    } finally {
      setloadingPod(false)
    }
  };


  const fetchDilveryData = async () => {
    // Limit to current delivery person's assignments using stable id match
    const uid = userProfile?.id || userProfile?.uid || ''
    let q = supabase
      .from('delivery_boy_data')
      .select('id, created_at, assigned_user, lr_numbers, vehicle_no, status, delivery_boy_status')
      .order('created_at', { ascending: false })
    if (uid) {
      // assigned_user @> { id: uid }
      q = q.contains('assigned_user', { id: uid })
    }
    const { data, error } = await q
    if (error) return
    setDeliveryBoyList(data || [])
  }
  console.log(deliveryBoyList)
  // console.log(deliveryBoyList)
  const fetchPickupList = async () => {
    setPickupList([])
  }
  // console.log(pickupList)
  const extractLrNumbers = () => {
    const numbers = deliveryBoyList
      .flatMap((deliveryBoy) => deliveryBoy.lr_numbers || deliveryBoy.lrNumber)
      .map((v) => (v ?? '').toString().trim())
      .filter((v) => v.length > 0)
    setLrNumberdata(numbers)
  };
  const fetchOrderList = async () => {
    if (!Array.isArray(lrNumberdata) || lrNumberdata.length === 0) return
    try {
      const list = Array.from(new Set(lrNumberdata.map(v => (v ?? '').toString()))).filter(Boolean)
      if (list.length === 0) return setOrderList([])

      const { data, error } = await supabase
        .from('orders')
        .select('*')
        .in('order_number', list)
        .order('created_at', { ascending: false })
      if (error) {
        console.warn('fetchOrderList by order_number failed', error)
        setOrderList([])
        return
      }
      setOrderList(data || [])
    } catch (e) {
      console.error('Error in fetchOrderList:', e)
    }
  };
  console.log(lrNumberdata)
  console.log(orderList)
  useEffect(() => {
    extractLrNumbers();
  }, [deliveryBoyList]);
  useEffect(() => {
    fetchOrderList();
  }, [lrNumberdata]);
  useEffect(() => {
    fetchPickupList()
    fetchDilveryData()
  }, [userProfile?.name])
  return (
    <div className='crm-app-shell flex min-h-screen gap-3 p-3'>
      <Sidebar />
      <div className='crm-page-scroll flex min-w-0 flex-1 flex-col'>
      <UpdateDeliveryModal loadingPod={loadingPod} setloadingPod={setloadingPod} setReason={setReason} reason={reason} addPOD={addPOD} pod={pod} status={status} setStatus={setStatus} handleUpdateStatus={handleUpdateStatus} updateModal={updateModal} handleUpdateModal={handleUpdateModal} setUpdateModal={setUpdateModal} handleDeliveryBoyStatus={handleDeliveryBoyStatus} />
      <Topbar />
      <DeliveryListing orderList={orderList} deliveryId={deliveryId} setDeliveryId={setDeliveryId} fetchOrderDetails={fetchOrderDetails} handleUpdateModal={handleUpdateModal} pickupList={pickupList} />
      </div>
    </div>
  )
}

export default DeliveryBoyList
